<template>
  <div class="shopingCart">
    <p class="titlehead"> <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>提交订单</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="main">
      <div class="main-box">
        <h3>填写并核对订单信息</h3>
        <myorderTable @getAddress="getAddress"  @passVaule="passValue" ref="son"></myorderTable>
        <div class="money">
            <div><span class="one">{{totalnum}} 件商品，总商品金额:</span><span class="two">￥{{childData.subtotal_price}}</span></div>
            <div v-if="childData.is_dry_ice == 1"><span class="one">干冰:</span><span class="two">￥{{childData.dry_ice_price}}</span></div>
            <div v-if="childData.free_shipping == 0 &&  this.getAddressData !== undefined"><span class="one">运输包装费: <a href="javascript:;" @click="goyunfei()">运输包装费详情</a></span><span class="two">{{getAddressData.is_jzh == 0 ? 20 : 10}}</span></div>
            <div v-if="childData.free_shipping == 1 &&  this.getAddressData !== undefined"><span class="one">运输包装费: <a href="javascript:;" @click="goyunfei()">运输包装费详情</a></span><span class="two">包邮</span></div>
            <div><span class="one">订单总金额:</span><span class="two">￥{{childData.free_shipping == 1 ? childData.total_price + 0  :  getAddressData.is_jzh == 0 ? childData.total_price + 20 : childData.total_price + 10}}</span></div>
       </div>
        <button class="submit" @click="submit">提交订单</button>
      </div>
    </div>
    <div class="rightfixed">
      <ul :class="searchBarFixed == true ? 'isFixed' : ''">
        <rightFixed></rightFixed>
      </ul>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import rightFixed from "../../productCenter/components/rightFixed";
import Bottom from '../../../components/bottom'
import myorderTable from "../components/myorderTable"
export default {
  name: "shopingCart",
  data () {
    return{
      searchBarFixed: false,
      offsetTop: 0,
      totalnum:this.$route.query.totalnum,
      childData:[],
      getAddressData:[]
    }
  },
  components: {
    Bottom,
    rightFixed,
    myorderTable
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    passValue(data) {
      this.childData = data;
    },
    getAddress(data){
      this.getAddressData = data
    },
    goyunfei(){
      let routeUrl = this.$router.resolve({path:'/html',query:{
        type:"freight",
        index:3
      }})
      window.open(routeUrl.href, "_blank");
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector(".rightfixed").offsetTop+'px';
      if (scrollTop > offsetTop) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    },
    submit(){
      this.$refs.son.submit()
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
*{
  font-size: 16px;;
}
.shopingCart {
  width: 1920px;
  min-height: 1566px;
  background: #efefef;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  position: relative;
  .titlehead {
    height: 19px;
    font-size: 16px;
    text-align: left;
    color: #666666;
    line-height: 19px;
    padding-top: 25px;
    margin-bottom: 36px;
    margin-left: 335px;
     /deep/.el-breadcrumb__inner.is-link{
      color:#666666
    }
  }
  .main {
    width: 1510px;
    min-height: 850px;
    background: #ffffff;
    margin: auto;
    .main-box{
      width: 1250px;
      min-height:950px;
      margin: auto;
      padding-top: 30px; 
      h3{
        width: 162px;
        height: 24px;
        font-size: 18px;
        color: #666666;
     }
     .money{
        width: 1250px;
        div{
            margin-top: 17px;
            font-size: 16px;
            color: #666666;
            padding-left: 900px;
            position: relative;
            .two{
              position: absolute;
              right:50px;
            }
            span{
                &.one{
                margin-right: 80px;
                }  
                a{
                  font-size: 12px;
                }
            }
        }
     }
     .submit{
        width: 190px;
        height: 68px;
        background: #003871;
        color:#fff;
        font-size: 24px;
        font-weight: 700;
        line-height: 31px;
        margin: 22px 0px;
        margin-left: 1004px;
     }
     button{
         border:0px
     }
    }
  }
   .rightfixed {
      width: 90px;
      height: 230px;
      position: absolute;
      top: 550px;
      right: 10px;
      .isFixed {
        position: fixed;
        bottom: 150px;
        z-index: 999;
      }
    }
    .box-one {
      width: 1510px;
      height: 316px;
      background: #f6f6f6;
      margin: auto;
      background: url("../../../images/four.png");
      margin-top: 16px;
    }
    .five {
      width: 805px;
      height: 49px;
      margin: auto;
      margin-top: 15px;
      font-size: 16px;
      text-align: center;
      color: #666666;
      line-height: 24px;
      span {
        font-size: 16px;
        text-align: center;
        color: #666666;
        line-height: 24px;
      }
    }
}
</style>